<template>
	<div>
		HR Documents
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isLoading: false
			};
		},
		created() {
			this.isLoading = true;
			this.$store.dispatch('setPageTitle', 'HR Documents');
		}
	};
</script>

<style></style>
